module.exports = __webpack_public_path__ + "img/box.4c704d44.svg";